import { render, staticRenderFns } from "./BookingView.vue?vue&type=template&id=52347f1a&scoped=true&"
import script from "./BookingView.vue?vue&type=script&lang=js&"
export * from "./BookingView.vue?vue&type=script&lang=js&"
import style0 from "./BookingView.vue?vue&type=style&index=0&id=52347f1a&scoped=true&lang=css&"
import style1 from "@/assets/css/user_booking.css?vue&type=style&index=1&lang=css&"
import style2 from "./BookingView.vue?vue&type=style&index=2&id=52347f1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52347f1a",
  null
  
)

export default component.exports